export interface EnvironmentConfig {
  apiUrls: string[];
  environment: 'development' | 'production';
  timeout: number;
  retryAttempts: number;
}

const developmentConfig: EnvironmentConfig = {
  apiUrls: [
    // Google Apps Script Web App URL (set your deployment URL here)
    (typeof localStorage !== 'undefined' && localStorage.getItem('gs_api_base')) ||
    'https://script.google.com/macros/s/YOUR_DEPLOYMENT_ID/exec'
  ],
  environment: 'development',
  timeout: 10000,
  retryAttempts: 3
};

const productionConfig: EnvironmentConfig = {
  apiUrls: [
    (typeof localStorage !== 'undefined' && localStorage.getItem('gs_api_base')) ||
    'https://script.google.com/macros/s/YOUR_DEPLOYMENT_ID/exec'
  ],
  environment: 'production',
  timeout: 15000,
  retryAttempts: 5
};

export const getEnvironmentConfig = (): EnvironmentConfig => {
  // Use process.env.NODE_ENV to detect development vs production
  // __DEV__ is React Native specific, so we use NODE_ENV for web/Electron
  const isDevelopment = process.env.NODE_ENV === 'development';
  return isDevelopment ? developmentConfig : productionConfig;
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};
